/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet-async';

import WelcomePage from '../WelcomePage/WelcomePage';

import styles from './InvalidTenant.module.css';

const messages = defineMessages({
  invalidTenant: 'Invalid Tenant',
  details: 'The tenant {tenantId} is not a valid tenant. Check your URL.',
});

const propTypes = {
  tenantId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  docURL: PropTypes.string,
};

const defaultProps = {
  docURL: null,
};

const InvalidTenant = ({ intl: { formatMessage }, tenantId, title, docURL }) => (
  <section className={styles.invalidTenant}>
    <Helmet>
      <title>{`${title} | ${formatMessage(messages.invalidTenant)}`}</title>
    </Helmet>
    <WelcomePage
      title={title}
      tenantId={tenantId}
      docURL={docURL}
      errorMessageType="error"
      errorMessage={formatMessage(messages.invalidTenant)}
      errorMessageDetails={formatMessage(messages.details, { tenantId })}
    />
  </section>
);

InvalidTenant.propTypes = propTypes;
InvalidTenant.defaultProps = defaultProps;

export default injectIntl(InvalidTenant);
